export default from './content-excerpt';



// WEBPACK FOOTER //
// ./app/components/content-excerpt/index.js